export class HeaderScrollService {
  private lastScrollY: number;

  private removeLogoClassTimeoutId: number | null = null;
  private readonly removeLogoClassDelayMs: number = 375;

  private getRootElement(): HTMLElement {
    return document.documentElement;
  }

  private clearRemoveLogoClassTimeout(): void {
    if (this.removeLogoClassTimeoutId === null) {
      return;
    }

    window.clearTimeout(this.removeLogoClassTimeoutId);
    this.removeLogoClassTimeoutId = null;
  }

  constructor() {
    this.lastScrollY = window.scrollY;
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll(): void {
    const currentScrollY: number = window.scrollY;

    if (currentScrollY <= 0) {
      this.getRootElement().classList.remove('header-scrolled-back');
      this.getRootElement().classList.remove('header-scrolled-back-logo');

      this.clearRemoveLogoClassTimeout();
      this.lastScrollY = currentScrollY;
      return;
    }

    if (currentScrollY > this.lastScrollY) {
      this.getRootElement().classList.remove('header-scrolled-back');

      this.removeLogoClassTimeoutId ??= window.setTimeout((): void => {
        this.getRootElement().classList.remove('header-scrolled-back-logo');
        this.removeLogoClassTimeoutId = null;
      }, this.removeLogoClassDelayMs);
    }

    if (currentScrollY < this.lastScrollY) {
      this.clearRemoveLogoClassTimeout();
      this.getRootElement().classList.add('header-scrolled-back');
      this.getRootElement().classList.add('header-scrolled-back-logo');
    }

    this.lastScrollY = currentScrollY;
  }
}
